/** Snippet builders for POST /api/send-message/* examples (display-only). */

export function buildSmsApiExamples(apiBase) {
  const url = `${apiBase}/send-message/sms`;
  return {
    php: `<?php
$url = '${url}';
$body = [
    'deviceId' => 'YOUR_DEVICE_ID',
    'to' => '923037900571',
    'text' => 'Hello',
    'token' => 'YOUR_API_KEY',
];
$ch = curl_init($url);
curl_setopt_array($ch, [
    CURLOPT_POST => true,
    CURLOPT_HTTPHEADER => ['Content-Type: application/json'],
    CURLOPT_POSTFIELDS => json_encode($body),
    CURLOPT_RETURNTRANSFER => true,
]);
$response = curl_exec($ch);
curl_close($ch);
echo $response;`,

    node: `const url = '${url}';
const res = await fetch(url, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    deviceId: 'YOUR_DEVICE_ID',
    to: '923037900571',
    text: 'Hello',
    token: 'YOUR_API_KEY',
  }),
});
const data = await res.json();
console.log(data);`,

    python: `import requests

url = '${url}'
payload = {
    'deviceId': 'YOUR_DEVICE_ID',
    'to': '923037900571',
    'text': 'Hello',
    'token': 'YOUR_API_KEY',
}
r = requests.post(url, json=payload, timeout=30)
print(r.status_code, r.json())`,

    curl: `curl -sS -X POST '${url}' \\
  -H 'Content-Type: application/json' \\
  -d '{"deviceId":"YOUR_DEVICE_ID","to":"923037900571","text":"Hello","token":"YOUR_API_KEY"}'`,

    csharp: `using System.Net.Http;
using System.Text;
using System.Text.Json;

var url = "${url}";
var payload = new {
    deviceId = "YOUR_DEVICE_ID",
    to = "923037900571",
    text = "Hello",
    token = "YOUR_API_KEY"
};
var json = JsonSerializer.Serialize(payload);
using var client = new HttpClient();
var content = new StringContent(json, Encoding.UTF8, "application/json");
var res = await client.PostAsync(url, content);
Console.WriteLine(await res.Content.ReadAsStringAsync());`,
  };
}

export function buildSendTextApiExamples(apiBase) {
  const url = `${apiBase}/send-message/send`;
  return {
    php: `<?php
$url = '${url}';
$body = [
    'client_id' => 'YOUR_INSTANCE_ID',
    'mobile' => '923037900571',
    'content' => ['text' => 'Hello'],
    'token' => 'YOUR_API_KEY',
];
$ch = curl_init($url);
curl_setopt_array($ch, [
    CURLOPT_POST => true,
    CURLOPT_HTTPHEADER => ['Content-Type: application/json'],
    CURLOPT_POSTFIELDS => json_encode($body),
    CURLOPT_RETURNTRANSFER => true,
]);
echo curl_exec($ch);`,

    node: `const url = '${url}';
const res = await fetch(url, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    client_id: 'YOUR_INSTANCE_ID',
    mobile: '923037900571',
    content: { text: 'Hello' },
    token: 'YOUR_API_KEY',
  }),
});
console.log(await res.json());`,

    python: `import requests

url = '${url}'
payload = {
    'client_id': 'YOUR_INSTANCE_ID',
    'mobile': '923037900571',
    'content': {'text': 'Hello'},
    'token': 'YOUR_API_KEY',
}
r = requests.post(url, json=payload, timeout=60)
print(r.json())`,

    curl: `curl -sS -X POST '${url}' \\
  -H 'Content-Type: application/json' \\
  -d '{"client_id":"YOUR_INSTANCE_ID","mobile":"923037900571","content":{"text":"Hello"},"token":"YOUR_API_KEY"}'`,

    csharp: `var url = "${url}";
var payload = new {
    client_id = "YOUR_INSTANCE_ID",
    mobile = "923037900571",
    content = new { text = "Hello" },
    token = "YOUR_API_KEY"
};
using var client = new HttpClient();
var res = await client.PostAsync(url,
  new StringContent(JsonSerializer.Serialize(payload), Encoding.UTF8, "application/json"));
Console.WriteLine(await res.Content.ReadAsStringAsync());`,
  };
}

export function buildSendMediaApiExamples(apiBase) {
  const url = `${apiBase}/send-message/send-media`;
  return {
    php: `<?php
// multipart/form-data: file, client_id, mobile, message, token, mimetype, filename, fromTemplet, type
$ch = curl_init('${url}');
curl_setopt_array($ch, [
    CURLOPT_POST => true,
    CURLOPT_POSTFIELDS => [
        'file' => new CURLFile('/path/to/image.jpg'),
        'client_id' => 'YOUR_INSTANCE_ID',
        'mobile' => '923037900571',
        'message' => 'Caption text',
        'token' => 'YOUR_API_KEY',
        'mimetype' => 'image/jpeg',
        'filename' => 'image.jpg',
        'fromTemplet' => 'false',
        'type' => 'media',
    ],
    CURLOPT_RETURNTRANSFER => true,
]);
echo curl_exec($ch);`,

    node: `const FormData = require('form-data');
const fs = require('fs');
const form = new FormData();
form.append('file', fs.createReadStream('./photo.jpg'));
form.append('client_id', 'YOUR_INSTANCE_ID');
form.append('mobile', '923037900571');
form.append('message', 'Caption text');
form.append('token', 'YOUR_API_KEY');
form.append('mimetype', 'image/jpeg');
form.append('filename', 'photo.jpg');
form.append('fromTemplet', 'false');
form.append('type', 'media');
const res = await fetch('${url}', { method: 'POST', body: form });
console.log(await res.json());`,

    python: `import requests

url = '${url}'
files = {'file': open('photo.jpg', 'rb')}
data = {
    'client_id': 'YOUR_INSTANCE_ID',
    'mobile': '923037900571',
    'message': 'Caption text',
    'token': 'YOUR_API_KEY',
    'mimetype': 'image/jpeg',
    'filename': 'photo.jpg',
    'fromTemplet': 'false',
    'type': 'media',
}
r = requests.post(url, files=files, data=data, timeout=120)
print(r.json())`,

    curl: `curl -sS -X POST '${url}' \\
  -F 'file=@/path/to/photo.jpg' \\
  -F 'client_id=YOUR_INSTANCE_ID' \\
  -F 'mobile=923037900571' \\
  -F 'message=Caption text' \\
  -F 'token=YOUR_API_KEY' \\
  -F 'mimetype=image/jpeg' \\
  -F 'filename=photo.jpg' \\
  -F 'fromTemplet=false' \\
  -F 'type=media'`,

    csharp: `// Use MultipartFormDataContent: append "file" StreamContent + fields client_id, mobile, message, token, mimetype, filename, fromTemplet, type
var url = "${url}";
using var form = new MultipartFormDataContent();
form.Add(new StreamContent(File.OpenRead("photo.jpg")), "file", "photo.jpg");
form.Add(new StringContent("YOUR_INSTANCE_ID"), "client_id");
form.Add(new StringContent("923037900571"), "mobile");
form.Add(new StringContent("Caption"), "message");
form.Add(new StringContent("YOUR_API_KEY"), "token");
form.Add(new StringContent("image/jpeg"), "mimetype");
form.Add(new StringContent("photo.jpg"), "filename");
form.Add(new StringContent("false"), "fromTemplet");
form.Add(new StringContent("media"), "type");
using var client = new HttpClient();
var res = await client.PostAsync(url, form);
Console.WriteLine(await res.Content.ReadAsStringAsync());`,
  };
}

export function buildSendContactApiExamples(apiBase) {
  const url = `${apiBase}/send-message/send-contact`;
  return {
    php: `<?php
$ch = curl_init('${url}');
curl_setopt_array($ch, [
    CURLOPT_POST => true,
    CURLOPT_POSTFIELDS => [
        'client_id' => 'YOUR_INSTANCE_ID',
        'mobile' => '923037900571',
        'name' => 'Jane Doe',
        'phone' => '923001122334',
        'token' => 'YOUR_API_KEY',
        'type' => 'contact',
    ],
    CURLOPT_RETURNTRANSFER => true,
]);
echo curl_exec($ch);`,

    node: `const form = new FormData();
form.append('client_id', 'YOUR_INSTANCE_ID');
form.append('mobile', '923037900571');
form.append('name', 'Jane Doe');
form.append('phone', '923001122334');
form.append('token', 'YOUR_API_KEY');
form.append('type', 'contact');
const res = await fetch('${url}', { method: 'POST', body: form });
console.log(await res.json());`,

    python: `import requests

url = '${url}'
data = {
    'client_id': 'YOUR_INSTANCE_ID',
    'mobile': '923037900571',
    'name': 'Jane Doe',
    'phone': '923001122334',
    'token': 'YOUR_API_KEY',
    'type': 'contact',
}
r = requests.post(url, data=data, timeout=60)
print(r.json())`,

    curl: `curl -sS -X POST '${url}' \\
  -F 'client_id=YOUR_INSTANCE_ID' \\
  -F 'mobile=923037900571' \\
  -F 'name=Jane Doe' \\
  -F 'phone=923001122334' \\
  -F 'token=YOUR_API_KEY' \\
  -F 'type=contact'`,

    csharp: `using var form = new MultipartFormDataContent();
form.Add(new StringContent("YOUR_INSTANCE_ID"), "client_id");
form.Add(new StringContent("923037900571"), "mobile");
form.Add(new StringContent("Jane Doe"), "name");
form.Add(new StringContent("923001122334"), "phone");
form.Add(new StringContent("YOUR_API_KEY"), "token");
form.Add(new StringContent("contact"), "type");
using var client = new HttpClient();
var res = await client.PostAsync("${url}", form);
Console.WriteLine(await res.Content.ReadAsStringAsync());`,
  };
}

export function buildSendLocationApiExamples(apiBase) {
  const url = `${apiBase}/send-message/send-location`;
  return {
    php: `<?php
$ch = curl_init('${url}');
curl_setopt_array($ch, [
    CURLOPT_POST => true,
    CURLOPT_POSTFIELDS => [
        'client_id' => 'YOUR_INSTANCE_ID',
        'mobile' => '923037900571',
        'latitude' => '24.8607',
        'longitude' => '67.0011',
        'text' => 'Here',
        'token' => 'YOUR_API_KEY',
        'type' => 'location',
    ],
    CURLOPT_RETURNTRANSFER => true,
]);
echo curl_exec($ch);`,

    node: `const form = new FormData();
form.append('client_id', 'YOUR_INSTANCE_ID');
form.append('mobile', '923037900571');
form.append('latitude', '24.8607');
form.append('longitude', '67.0011');
form.append('text', 'Here');
form.append('token', 'YOUR_API_KEY');
form.append('type', 'location');
const res = await fetch('${url}', { method: 'POST', body: form });
console.log(await res.json());`,

    python: `import requests

url = '${url}'
data = {
    'client_id': 'YOUR_INSTANCE_ID',
    'mobile': '923037900571',
    'latitude': '24.8607',
    'longitude': '67.0011',
    'text': 'Here',
    'token': 'YOUR_API_KEY',
    'type': 'location',
}
r = requests.post(url, data=data, timeout=60)
print(r.json())`,

    curl: `curl -sS -X POST '${url}' \\
  -F 'client_id=YOUR_INSTANCE_ID' \\
  -F 'mobile=923037900571' \\
  -F 'latitude=24.8607' \\
  -F 'longitude=67.0011' \\
  -F 'text=Here' \\
  -F 'token=YOUR_API_KEY' \\
  -F 'type=location'`,

    csharp: `using var form = new MultipartFormDataContent();
form.Add(new StringContent("YOUR_INSTANCE_ID"), "client_id");
form.Add(new StringContent("923037900571"), "mobile");
form.Add(new StringContent("24.8607"), "latitude");
form.Add(new StringContent("67.0011"), "longitude");
form.Add(new StringContent("Here"), "text");
form.Add(new StringContent("YOUR_API_KEY"), "token");
form.Add(new StringContent("location"), "type");
using var client = new HttpClient();
var res = await client.PostAsync("${url}", form);
Console.WriteLine(await res.Content.ReadAsStringAsync());`,
  };
}

/** Uses logged-in JWT (Authorization), not API key in body. */
export function buildSendGroupApiExamples(apiBase) {
  const url = `${apiBase}/send-message/send-to-group`;
  return {
    php: `<?php
$url = '${url}';
$jwt = 'YOUR_LOGIN_JWT';
$body = [
    'type' => 'type',
    'typedMsg' => 'Hello everyone',
    'client_id' => 'YOUR_INSTANCE_ID',
    'groupData' => [
        'id' => '120363123456789012@g.us',
        'name' => 'My Group',
    ],
];
$ch = curl_init($url);
curl_setopt_array($ch, [
    CURLOPT_POST => true,
    CURLOPT_HTTPHEADER => [
        'Content-Type: application/json',
        'Authorization: Bearer ' . $jwt,
    ],
    CURLOPT_POSTFIELDS => json_encode($body),
    CURLOPT_RETURNTRANSFER => true,
]);
echo curl_exec($ch);`,

    node: `const url = '${url}';
const res = await fetch(url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + process.env.JWT,
  },
  body: JSON.stringify({
    type: 'type',
    typedMsg: 'Hello everyone',
    client_id: 'YOUR_INSTANCE_ID',
    groupData: {
      id: '120363123456789012@g.us',
      name: 'My Group',
    },
  }),
});
console.log(await res.json());`,

    python: `import requests

url = '${url}'
headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer YOUR_LOGIN_JWT',
}
payload = {
    'type': 'type',
    'typedMsg': 'Hello everyone',
    'client_id': 'YOUR_INSTANCE_ID',
    'groupData': {
        'id': '120363123456789012@g.us',
        'name': 'My Group',
    },
}
r = requests.post(url, json=payload, headers=headers, timeout=60)
print(r.json())`,

    curl: `curl -sS -X POST '${url}' \\
  -H 'Content-Type: application/json' \\
  -H 'Authorization: Bearer YOUR_LOGIN_JWT' \\
  -d '{"type":"type","typedMsg":"Hello everyone","client_id":"YOUR_INSTANCE_ID","groupData":{"id":"120363123456789012@g.us","name":"My Group"}}'`,

    csharp: `var url = "${url}";
using var req = new HttpRequestMessage(HttpMethod.Post, url);
req.Headers.Authorization = new AuthenticationHeaderValue("Bearer", "YOUR_LOGIN_JWT");
req.Content = new StringContent(JsonSerializer.Serialize(new {
    type = "type",
    typedMsg = "Hello everyone",
    client_id = "YOUR_INSTANCE_ID",
    groupData = new { id = "120363123456789012@g.us", name = "My Group" }
}), Encoding.UTF8, "application/json");
using var client = new HttpClient();
var res = await client.SendAsync(req);
Console.WriteLine(await res.Content.ReadAsStringAsync());`,
  };
}
